import { forwardRef } from 'react';

/** Invisible reCAPTCHA container — actual rendering handled by useRecaptcha(). */
const RecaptchaWidget = forwardRef<HTMLDivElement>((_props, ref) => <div ref={ref} />);

export default RecaptchaWidget;
